import { render, staticRenderFns } from "./modal-onboardingTodos.vue?vue&type=template&id=4db2eff6&scoped=true&"
import script from "./modal-onboardingTodos.vue?vue&type=script&lang=js&"
export * from "./modal-onboardingTodos.vue?vue&type=script&lang=js&"
import style0 from "./modal-onboardingTodos.vue?vue&type=style&index=0&id=4db2eff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2eff6",
  null
  
)

export default component.exports